/**
 * PeopleAlsoViewed — network-style "People also viewed" rail on other users'
 * profile pages. Backend: GET /api/network/also-viewed/{user_id}
 */
import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../../App';
import { Users } from 'lucide-react';

const PeopleAlsoViewed = ({ userId }) => {
  const { API } = useContext(AuthContext);
  const [members, setMembers] = useState([]);

  useEffect(() => {
    if (!userId) return undefined;
    let alive = true;
    axios.get(`${API}/network/also-viewed/${userId}`)
      .then((r) => { if (alive) setMembers(r.data?.members || []); })
      .catch(() => {});
    return () => { alive = false; };
  }, [API, userId]);

  if (members.length === 0) return null;

  return (
    <aside className="pro-card p-4" data-testid="people-also-viewed">
      <div className="flex items-center gap-2 mb-3">
        <Users className="w-4 h-4 text-primary" />
        <span className="font-heading font-extrabold text-sm">People also viewed</span>
      </div>
      <ul className="space-y-2">
        {members.slice(0, 5).map((p) => (
          <li key={p.id} className="flex items-center gap-2" data-testid={`also-viewed-${p.id}`}>
            <Link
              to={`/u/${p.handle || p.id}`}
              className="h-8 w-8 rounded-full bg-primary/15 text-primary flex items-center justify-center text-[10px] font-bold flex-shrink-0 overflow-hidden"
            >
              {p.avatar_url
                ? <img src={p.avatar_url} alt="" className="h-full w-full object-cover" />
                : (p.name || '?').slice(0, 2).toUpperCase()}
            </Link>
            <div className="min-w-0 flex-1">
              <Link to={`/u/${p.handle || p.id}`} className="text-xs font-semibold truncate block hover:text-primary transition-colors">
                {p.name}
              </Link>
              {p.headline && (
                <div className="text-[10px] text-muted-foreground truncate">{p.headline}</div>
              )}
            </div>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default PeopleAlsoViewed;
